import { useSelector } from 'react-redux';
import Header from 'components/common/Header';
import SubNavigation from 'components/common/SubNavigation';
import { Store } from 'components/common/types/Store.types';
import { LabsReportDropdown } from '../LabsReportDropdown/LabsReportDropdown';
import useHasInsightsAccess from '../InsightsAccess';

const InsightsHeader: React.FC = () => {
  const { hasAccess, showLabsDropdown } = useHasInsightsAccess();
  const environment = useSelector((state: Store) => state.environment.environmentId);

  const isDealHealthGaVisible =
    !hasAccess.tabs.dealHealthChina && (environment === 'JCDECAUX_US' ? hasAccess.tabs.dealHealth : true);

  const thoughtspotInsightsTabs = [
    {
      id: 1,
      path: '/insights/deal-health',
      isVisible: isDealHealthGaVisible,
      name: 'Deal health',
    },
    {
      id: 2,
      path: '/insights/china-deal-health',
      isVisible: hasAccess.tabs.dealHealthChina,
      name: 'Deal health',
    },
    {
      id: 3,
      path: '/insights/us-deal-health',
      isVisible: hasAccess.tabs.dealHealthUS,
      name: 'Deal health 2.0',
    },
    {
      id: 4,
      path: '/insights/proof-of-play',
      isVisible: !hasAccess.tabs.proofOfPlayChina,
      name: 'Proof of play',
    },
    {
      id: 5,
      path: '/insights/china-proof-of-play',
      isVisible: hasAccess.tabs.proofOfPlayChina,
      name: 'Proof of play',
    },
    {
      id: 6,
      path: '/insights/pop-live-monitoring',
      isVisible: hasAccess.tabs.popLiveMonitoring,
      name: 'Pop live monitoring',
    },
    {
      id: 7,
      path: '/insights/revenue-insights',
      isVisible: hasAccess.tabs.revenueInsights,
      name: 'Revenue insights',
    },
    {
      id: 8,
      path: '/insights/inventory-reservation',
      isVisible: hasAccess.tabs.inventoryReservation,
      name: 'Inventory reservation',
    },
  ];

  return (
    <Header
      title="Insights"
      subNavigation={<SubNavigation tabsConfig={thoughtspotInsightsTabs} />}
      actionButton={showLabsDropdown ? <LabsReportDropdown /> : null}
    />
  );
};

export default InsightsHeader;
